export const USER_ACTIONS = {
  LOGGED_IN: 'LOGGED_IN',
  UPDATE: 'UPDATE_USER_DATA',
  CLEAR: 'CLEAR',
  SAVE: 'SAVE',
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
};

export const STORAGE_USER_NAMESPACE = 'storage_user_name_space';
